import clsx from 'clsx';
import React from 'react';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { cn } from '@/src/util/ui';

import DisplayTag from '../DisplayTag/DisplayTag';
import { getFullLabel } from '../Helper';

const SelectedTags = ({ tags, tagKey, editMode, isInputFocused, onRemove, onUpdate, children }) => {
  const selectedContainerClasses = cn(
    'container--selectedItems',
    'tw-w-full',
    'tw-flex tw-items-center tw-flex-wrap'
  );

  if (isInputFocused) {
    return (
      <div className={selectedContainerClasses}>
        {tags.map((tag, index) => {
          return (
            <DisplayTag
              key={`${tagKey}_${index}`}
              tags={tags}
              tag={tag}
              tagKey={tagKey}
              editMode={editMode}
              index={index}
              onRemove={onRemove}
              onUpdate={onUpdate}
            />
          );
        })}
        {children}
      </div>
    );
  }

  return (
    <div className={selectedContainerClasses}>
      {tags.slice(0, 5).map((tag, index) => {
        return (
          <DisplayTag
            key={`${tagKey}_${index}`}
            tags={tags}
            tag={tag}
            tagKey={tagKey}
            editMode={editMode}
            index={index}
            onRemove={onRemove}
            onUpdate={onUpdate}
          />
        );
      })}
      {tags.length > 5 && (
        <div
          className={clsx(
            'tw-group',
            'tw-flex tw-items-center',
            'tw-border-solid tw-border-[1px] tw-rounded-[3px]',
            'tw-px-[10px] tw-py-[3px] tw-mr-[5px] tw-mb-[5px]',
            'tw-font-brandonTextMedium',
            'tw-text-cfo-blue-700 tw-border-cfo-blue-300 tw-bg-cfo-blue-200'
          )}
        >
          <span
            data-tooltip-id={`tooltip_selected_notes_members`}
            className={clsx('tw-leading-[20px]')}
          >
            +{tags.length - 5}
          </span>

          <Tooltip
            className={clsx('tw-max-w-[500px]', 'tw-break-words')}
            id={`tooltip_selected_notes_members`}
            place="bottom"
            effect="solid"
          >
            {tags.slice(5).map((tag, index) => {
              const fullLabel = getFullLabel(tag);
              return <div key={`${tag.value}_${index}`}>{fullLabel}</div>;
            })}
          </Tooltip>
        </div>
      )}
      {children}
    </div>
  );
};

export default SelectedTags;
